import { render, staticRenderFns } from "./DeckView.vue?vue&type=template&id=03880de7"
import script from "./DeckView.vue?vue&type=script&lang=js"
export * from "./DeckView.vue?vue&type=script&lang=js"
import style0 from "./DeckView.vue?vue&type=style&index=0&id=03880de7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports